export const AuditEventHistoryFrontendFilterKeys = {
  EVENT_TYPE: 'eventType'
};
export const AuditEventHistoryApiFilterKeys = {
  USER_ID: 'userId',
  RANGE_TYPE: 'rangeType',
  START_DATE: 'startDate',
  END_DATE: 'endDate'
};
export const AuditEventHistoryFilterKeys = Object.assign({}, AuditEventHistoryFrontendFilterKeys, AuditEventHistoryApiFilterKeys);
export default AuditEventHistoryFilterKeys;